import React, { useMemo } from 'react';
import LazyLoad from 'react-lazyload';
import { string, number } from 'prop-types';
import * as styles from './styles/styles.module.scss';
import logoPro from './logo_pro.png';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import { LanguageSupportUtil } from '../../../utils/language_support_util';
import { DESKTOP_BREAKPOINT } from '../../../utils/constants/breakpoints';
import { EN_US } from '../../../utils/constants/LanguageRegionCode';

const BG_IMAGE_BASE = 'https://cdn-assets.alltrails.com/assets/images/homepage/pro_upsell_no_auth/';

const {
  strings: {
    HOME_PAGE: {
      PRO_UPSELL: { STAY_ON_TRACK, BUY_PRO, NO_CELL_SERVICE }
    }
  }
} = StringConstantsMixin;

const ProUpsellNoAuth = ({ languageRegionCode, windowWidth }) => {
  const shortRegionCode = languageRegionCode.split('-')[0];

  const featuresContainerStyle = useMemo(() => {
    const isDesktop = windowWidth && windowWidth >= DESKTOP_BREAKPOINT;

    if (!isDesktop) {
      return {};
    }

    const fileName = `bg_desktop_${shortRegionCode}.png`;
    const backgroundImageUrl = `${BG_IMAGE_BASE}${fileName}`;

    return {
      backgroundImage: `url(${backgroundImageUrl})`
    };
  }, [windowWidth]);

  const upperContainerStyle = {
    backgroundImage: `url(${BG_IMAGE_BASE}bg_mobile_${shortRegionCode}.png)`
  };

  return (
    <div className={styles.container}>
      <LazyLoad>
        <div style={upperContainerStyle} className={styles.upperContainer} />
      </LazyLoad>
      <div style={featuresContainerStyle} className={styles.contentContainer}>
        <LazyLoad>
          <img className={styles.logoProImage} src={logoPro} alt="" />
        </LazyLoad>
        <h2 className={styles.title}>{STAY_ON_TRACK}</h2>
        <p className={styles.text}>{NO_CELL_SERVICE}</p>
        <a href={LanguageSupportUtil.wrapUrlSafe('/pro?ref=homepage_pro_proupsellnoauth', languageRegionCode)} className={styles.buyLink}>
          {BUY_PRO}
        </a>
      </div>
    </div>
  );
};

ProUpsellNoAuth.propTypes = {
  languageRegionCode: string,
  windowWidth: number
};

ProUpsellNoAuth.defaultProps = {
  languageRegionCode: EN_US,
  windowWidth: null
};

export default ProUpsellNoAuth;
